var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-responsive',{class:[
    'image-crop-wrapper',
    {
      'image-crop-wrapper_defined_aspect-ratio': !!_vm.localAspectRatio,
      'image-crop-wrapper_defined_height': _vm.height,
      'image-crop-wrapper_circle': _vm.circle,
    },
  ],style:({
    '--align': _vm.align,
    '--valign': _vm.valign,
  }),attrs:{"id":_vm.containerId,"aspect-ratio":_vm.localAspectRatio,"height":_vm.height}},[(!_vm.isCroppedImageLoaded)?_c('v-skeleton-loader',{style:({
      position: 'absolute',
      top: 0,
      left: 0,
    }),attrs:{"type":"image","width":"100%","height":"100%"}}):_vm._e(),_c('img',{class:[
      'image-crop',
      {
        'image-crop_contain': _vm.contain,
        'image-crop_cover': !_vm.contain,
        'image-crop_loaded': _vm.isCroppedImageLoaded,
      },
    ],attrs:{"src":_vm.croppedImageUrl,"draggable":_vm.draggable},on:{"load":_vm.onLoad}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }